const CategoriesDisplay = {

  /**
   * @return {void}
   */
  initialize: function () {
    this.setup();
  },

  /**
   * @return void
   */
  setup: () => {

    let categories = document.querySelectorAll('.category-display-toggle');
    if (categories.length == 0) {
      return;
    }

    /**
     * Hide all elements but current
     * @return void
     */
    function reset() {

      [...categories].forEach(category => {
        category.style.display = 'none';
      });
    }

    let currentElement = 0;

    /**
     * Set current element to display or no
     * @return void
     */
    function toggleElementDisplay() {
      let element = categories[currentElement];

      if (typeof element === 'undefined') {
        currentElement = 0;
        element = categories[currentElement];
      }
      ;

      reset();

      element.style.display = 'contents';
      currentElement++;
    }

    /**
     * Add display toggle to show only single element each
     * @return void
     */
    let run = setInterval(function () {
      toggleElementDisplay();
    }, 3000);
  },
};

export default CategoriesDisplay;